import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pa-3"
}
const _hoisted_2 = {
  key: 0,
  class: "pl-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_TaxForm = _resolveComponent("TaxForm")!

  return (_ctx.companyId)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_row, {
          "no-gutters": "",
          class: "mb-2 rounded-xl bg-white pa-2"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "12",
              class: "d-flex align-center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn_back, {
                  class: "ml-2",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.back()))
                }),
                (_ctx.sheet)
                  ? (_openBlock(), _createElementBlock("h2", _hoisted_2, " Cerfa " + _toDisplayString(_ctx.sheet.name), 1))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_btn_toggle, {
                  modelValue: _ctx.formDisplayMode,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formDisplayMode) = $event)),
                  class: "ml-6",
                  group: "",
                  mandatory: "force",
                  rounded: "",
                  density: "compact"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      value: "TaxFormTable",
                      class: "mx-0",
                      disabled: !_ctx.containsCerfa
                    }, {
                      default: _withCtx(() => _cache[2] || (_cache[2] = [
                        _createTextVNode(" Saisie ")
                      ])),
                      _: 1
                    }, 8, ["disabled"]),
                    _createVNode(_component_v_btn, {
                      value: "TaxFormPng",
                      class: "ml-2",
                      disabled: !_ctx.containsCerfa
                    }, {
                      default: _withCtx(() => _cache[3] || (_cache[3] = [
                        _createTextVNode(" Cerfa ")
                      ])),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_ctx.sheet)
          ? (_openBlock(), _createBlock(_component_v_row, {
              key: 0,
              "no-gutters": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  class: "px-2 flex-grow-1 flex-shrink-0 document-card",
                  style: {"max-height":"calc(100vh - 140px)","overflow":"auto"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_TaxForm, {
                      ref: "taxForm",
                      cerfaNumber: null,
                      activeTab: _ctx.formDisplayMode,
                      sheet: _ctx.sheet,
                      loaded: !!_ctx.sheet,
                      enableEdition: _ctx.enableEdition,
                      isSent: true
                    }, null, 8, ["activeTab", "sheet", "loaded", "enableEdition"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}